"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogisticsSearchClient = void 0;
const LogisticsClient_1 = require("./LogisticsClient");
const commons_utils_1 = require("@deliverr/commons-utils");
class LogisticsSearchClient {
    constructor(indexName, options) {
        this.client = new LogisticsClient_1.LogisticsClient(indexName, Object.assign(Object.assign({}, options), { baseURL: options.baseURL || (0, commons_utils_1.getEnvString)("LOGISTICS_SEARCH_BASE_URL") }));
    }
    async search(options, params) {
        const rsp = await this.client.search(Object.assign({}, options), Object.assign({}, params));
        return rsp === null || rsp === void 0 ? void 0 : rsp.body;
    }
    async count(options) {
        const rsp = await this.client.count(Object.assign({}, options));
        return rsp === null || rsp === void 0 ? void 0 : rsp.body;
    }
    async scroll(options, params) {
        const DEFAULT_SCROLL_DURATION = "1m";
        let rsp = await this.client.search(Object.assign(Object.assign({}, options), { scroll: options.scroll.duration || DEFAULT_SCROLL_DURATION }), Object.assign({}, params));
        let scrollId = rsp === null || rsp === void 0 ? void 0 : rsp.body._scroll_id;
        options.scroll.callback(rsp === null || rsp === void 0 ? void 0 : rsp.body.hits.hits);
        while ((rsp === null || rsp === void 0 ? void 0 : rsp.body.hits.hits.length) > 0) {
            rsp = await this.client.search({
                query: options.query,
                scroll_id: scrollId,
                scroll: options.scroll.duration || DEFAULT_SCROLL_DURATION,
            });
            scrollId = rsp === null || rsp === void 0 ? void 0 : rsp.body._scroll_id;
            options.scroll.callback(rsp === null || rsp === void 0 ? void 0 : rsp.body.hits.hits);
        }
    }
}
exports.LogisticsSearchClient = LogisticsSearchClient;
//# sourceMappingURL=LogisticsSearchClient.js.map